import { render } from "./ChoosePageCompaniesSvg.vue?vue&type=template&id=6d8d157d"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__